var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArtifact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.5C11.5 13.6875 12.1562 13 13 13C13.8125 13 14.5 13.6875 14.5 14.5V17H13H11.5V14.5ZM15 13H23.5C25.1562 13 26.5 14.3438 26.5 16V22H20H19.5V22.5V24C19.5 25.125 18.5938 26 17.5 26C16.375 26 15.5 25.125 15.5 24V14.5C15.5 13.9375 15.3125 13.4375 15 13ZM26 27H23H17.5C19.1562 27 20.5 25.6562 20.5 24V23H29.5V23.5C29.5 25.4375 27.9062 27 26 27Z",
    fill: "#6A7289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtifact);
export default __webpack_public_path__ + "static/media/artifact.f33ec90ba3e99f83b465c019934d1858.svg";
export { ForwardRef as ReactComponent };